import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice } from '../../../utils/price-utils';
import { TimeButton } from './TimeButton.js';

const currencyLocale = process.env.REACT_APP_NODE_ENV === 'ie' ? 'en-GB' : 'fi-FI';

export class TimeListItem extends React.Component {

  _handleClick = (e) => {
    const {
      item,
      location,
      pro
    } = this.props;

    if (location.pathname.match(/^\/embed\/(.*)/)) {
      e.preventDefault();
      e.stopPropagation();
      try {
        const msg = {
          event: 'BTCalendarBookingLinkClicked',
          path: `/embed/pros/${pro.machine_name}/book/${item.serviceId}/${item.time.format('YYYY-MM-DDTHH:mm:ss')}?saleschannel=embed`,
        };
        window.parent.window.postMessage(JSON.stringify(msg), '*');
      } catch(e) {};
    }
  };

  render() {
    const {
      item,
      location,
      pro
    } = this.props;

    const disabled = item.disabled ? 'disabled' : null;

    return (
      <Link className="no-hover" to={{
        pathname: `/pros/${pro.machine_name}/book/${item.serviceId}/${item.time.format('YYYY-MM-DDTHH:mm:ss')}`,
        state: { modal: true, prevUrl: location.pathname, prevState: location.state }
      }} onClick={this._handleClick}>
        <TimeButton className={disabled}>
          <span className="time">{item.time.format('HH.mm')}</span>
          <span className="price">{formatPrice(item.price.price_value, pro.default_currency, currencyLocale)}</span>
        </TimeButton>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/pros/components/TimeListItem.js